import { useEffect, useState } from "react";

import { ReactComponent as DeleteSVG } from "../../../assets/icons/delete.svg";
import { ReactComponent as UpdateSVG } from "../../../assets/icons/refresh.svg";
import { AdditionalRequirement } from "../../../components/ClientCreatedJobDetails";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import ClientInformation from "../../../components/PrinterBrowsedJobDetails/ClientInformation";
import JobInformation from "../../../components/PrinterBrowsedJobDetails/JobInformation";
import PdfInformation from "../../../components/PrinterBrowsedJobDetails/PdfInformation";
import PropertyInformation from "../../../components/PrinterBrowsedJobDetails/PropertyInformation";
import RequirementInformation from "../../../components/PrinterBrowsedJobDetails/RequirementInformation";
import CostAndShipping from "../../../components/TechnicianBrowsedJobDetails/CostAndShipping";
import {
  Button,
  Divider,
  Modal,
  NavigateBack,
  Tag,
  Typography,
} from "../../../designComponents";
import { ActionsContainer } from "../../CreateJobs/ViewCreatedJobs/style";
import { PrinterDetailsContainerStyled } from "./style";
import { requestAPI, humanReadableDate } from "../../../utils";
import printerApi from "../../../APIs/printer";
import { useParams } from "react-router-dom";
import SelectDropDown from "../../../designComponents/SelectDropdown";
import { toast } from "react-toastify";

type ClientType = {
  _id: string;
  emailAddress: string;
};

type PrinterJobDetailsType = {
  _id: string;
  clientId: ClientType;
  jobTitle: string;
  notes: string;
  printerId:string;
  pdf: any[];
  shippingAddress: string;
  additionalRequirement: any[];
  printerJobStatus: string;
  printerJobStatusChangedDate: any[];
  createdAt: string;
  updatedAt: string;
};

type PrinterType = {
  user: string;
  fullName: string;
};

type PrinterOptionType = {
  label: string;
  value: string;
};

const PrinterJobDetails = () => {
  const [showModal, setShowModal] = useState(false);
  const [jobDetails, setJobDetails] = useState<PrinterJobDetailsType | null>(
    null,
  );
  const [printerOptions, setPrinterOptions] = useState<PrinterOptionType[]>([]);
  const { jobId } = useParams();
  const [selectedPrinter, setSelectedPrinter] = useState<string>("");

  const getPrinterJobWithId = async (jobId: string) => {
    try {
      const response = await requestAPI(printerApi.getPrinterJobById(jobId));
      const data = response;
      setJobDetails(data);
    } catch (error) {
      console.error("Error fetching job details:", error);
    }
  };

  const getApprovedPrinters = async () => {
    try {
      const response = await requestAPI(printerApi.getAllPrinter());
      const printers = response?.data?.data || response?.data || [];

      const options = printers.map((printer: PrinterType) => ({
        label: printer.fullName,
        value: printer.user,
      }));

      setPrinterOptions(options);
    } catch (error) {
      console.error("Error fetching printers:", error);
    }
  };
  const approvePrinter = async (id: string, selectedPrinter: string) => {
    try {
      await requestAPI(
        printerApi.asignPrinter(id, { printerId: selectedPrinter }),
      );
      toast("Successfully assigned");
    } catch (error) {
      toast("There was an error assgining");
    }
  };
  
  useEffect(() => {
    if (jobId) {
      getPrinterJobWithId(jobId);
    }
    getApprovedPrinters();
  }, [jobId]);

  if (!jobDetails) {
    return <div>Loading...</div>;
  }
  const getStatusType = (status: string) => {
    switch (status) {
      case "REQUESTED":
        return "warning";
      case "ACCEPTED":
        return "success";
      case "REJECTED":
        return "danger";
      default:
        return "success";
    }
  };

  return (
    <PrinterDetailsContainerStyled>
      <div
        style={{
          position: "sticky",
          top: "60px",
          zIndex: "999",
          paddingTop: "5px",
        }}
      >
        <NavigateBack />
      </div>
      <div className="container">
        <div className="heading">
          <Typography variant="title" className="heading">
            {jobDetails.jobTitle}
          </Typography>
          <Tag
            type={getStatusType(jobDetails.printerJobStatus)}
            style={{ padding: "3px 12px" }}
          >
            {jobDetails.printerJobStatus}
          </Tag>
        </div>
        <Divider spaceY="20px" />
        <JobInformation
          jobCreatedAt={humanReadableDate(jobDetails.createdAt)}
          jobTitle={jobDetails.jobTitle}
          notes={jobDetails.notes}
        />
        <Divider spaceY="20px" />

        <ClientInformation
          clientId={jobDetails.clientId._id}
          email={jobDetails.clientId.emailAddress}
        />
        <Divider spaceY="20px" />
        {/* <CostAndShipping
          pricing="€ 0" // Not available in API
          shippingAddress={jobDetails.shippingAddress}
        /> */}
        {/* <Divider spaceY="20px" /> */}
        <AdditionalRequirement
          additionalInfo={jobDetails.additionalRequirement}
        />
        <Divider spaceY="20px" />
        {jobDetails.pdf && jobDetails.pdf.length > 0 ? (
          jobDetails.pdf.map((pdf, index) => (
            <div key={index}>
              <PdfInformation
                pdfName={pdf.name || `PDF number ${index + 1}`}
                quantity={pdf.quantity || "1"}
                notes={pdf.notes || ""}
              />
              {index < jobDetails.pdf.length - 1 && <Divider spaceY="20px" />}
            </div>
          ))
        ) : (
          <Typography variant="normal">No PDFs available</Typography>
        )}
        <Divider spaceY="20px" />
        {!jobDetails.printerId && (
          <>
            <Typography
              variant="normal"
              strong
              fontColor="secondary"
              style={{ marginBottom: "20px" }}
            >
              ACTIONS
            </Typography>
            <ActionsContainer style={{ marginBottom: "24px" }}>
              <Button variant="secondary" onClick={() => setShowModal(true)}>
                {/* <UpdateSVG /> */}
                Accept
              </Button>
              {/* <Button variant="danger" onClick={() => setShowModal(true)}>
            <DeleteSVG /> Reject
          </Button> */}
            </ActionsContainer>
          </>
        )}
        {/* {showModal && (
          <ConfirmationModal
            message={`Are you sure you want to delete this job ?`}
            isOpen={showModal}
            onClose={() => setShowModal(false)}
            title="Delete Job"
          />
        )} */}
        <Modal
          open={showModal}
          onClose={() => {
            setShowModal(false);
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="normal"
              strong
              style={{ marginBottom: "16px" }}
            >
              Select Printer
            </Typography>
            <SelectDropDown
              onSelect={(value: string) => {
                setSelectedPrinter(value);
              }}
              options={printerOptions}
              selected={selectedPrinter}
            />
            <div style={{ display: "flex", gap: "12px", marginTop: "24px" }}>
              <Button
                variant="primary"
                onClick={() => {
                  if (jobId) approvePrinter(jobId, selectedPrinter);
                  setShowModal(false);
                }}
                disabled={!selectedPrinter}
              >
                Assign
              </Button>
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Cancel
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    </PrinterDetailsContainerStyled>
  );
};

export default PrinterJobDetails;
